import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {Observable} from 'rxjs/Rx';
import {Topic} from '../admin/topic/model/topic';
@Injectable()
export class TopicService {
constructor(private http: Http) { }

  private topicsUrl = 'https://api.gleanbee.com/';
     getTopic(h: string) : Observable<Topic> {

let headers      = new Headers({ 'Content-Type': 'text/plain'});
        let options       = new RequestOptions({ headers: headers, withCredentials: true  }); 


         return this.http.get(this.topicsUrl + "GetTopic/?h=" + h, options)
            .map((res:Response) => {
     console.log(res);
     let headers = res.headers;
     console.log(headers);
  })
            .catch((error:any) => Observable.throw(error.json().error || 'Server error'));
     }

     getTopics() : Observable<Topic[]> {

let headers      = new Headers({ 'Content-Type': 'text/plain'});
        let options       = new RequestOptions({ headers: headers, withCredentials: true  }); 


         return this.http.get(this.topicsUrl, options)
            .map((res:Response) => {
     console.log(res);
     let headers = res.headers;
     console.log(headers);
  })
            .catch((error:any) => Observable.throw(error.json().error || 'Server error'));
     }

     searchTopics(s: string, k: string, d: string) : Observable<Topic[]> {
         return this.http.get(this.topicsUrl + "SearchTopic/?s=" + s + "&k=" + k + "&d=" + d)
            .map((res:Response) => res.json())
            .catch((error:any) => Observable.throw(error.json().error || 'Server error'));
     }

     filterTopics(h: string, s: string, v: string, k: string, d: string) : Observable<Topic[]> {
         return this.http.get(this.topicsUrl + "FilterTopic/?h=" + h + "&s=" + s + "&v=" + v + "&k=" + k + "&d=" + d)
            .map((res:Response) => res.json())
            .catch((error:any) => Observable.throw(error.json().error || 'Server error'));
     }

    addTopic (body: Topic): Observable<Object> {
        let headers      = new Headers({ 'Content-Type': 'text/plain'}); // ... Set content type as text in order not to trigger preflight OPTIONS request
        let options       = new RequestOptions({ headers: headers }); // Create a request option
	let bodyString = JSON.stringify(body); // Stringify payload
  return this.http.post(this.topicsUrl + "topics/", bodyString, options) // ...using post request
                         .map((res:Response) => res) // ...and returning data
                         .catch((error:any) => Observable.throw(error || 'Server error')); //...errors if any
    }  

    updateTopic (body: Topic): Observable<Object> {
        let headers      = new Headers({ 'Content-Type': 'text/plain'}); // ... Set content type as text in order not to trigger preflight OPTIONS request
        let options       = new RequestOptions({ headers: headers}); // Create a request option
	let bodyString = JSON.stringify(body); // Stringify payload
  //alert(bodyString)
  return this.http.put(this.topicsUrl + "topics/" + body.ID, bodyString, options) // ...using post request
                         .map((res:Response) => {
     console.log(res);
     let headers = res.headers;
     console.log(headers);
  }) // ...and returning data
                         .catch((error:any) => Observable.throw(error || 'Server error')); //...errors if any
    }  

    cloneTopic (body: Topic): Observable<Object> {
        let headers      = new Headers({ 'Content-Type': 'text/plain'}); // ... Set content type as text in order not to trigger preflight OPTIONS request
        let options       = new RequestOptions({ headers: headers}); // Create a request option
	let bodyString = JSON.stringify(body); // Stringify payload
      //alert(bodyString)
      return this.http.put(this.topicsUrl + "/topics/clone/topic/from/to/new", bodyString, options) // ...using post request
                         .map((res:Response) => {
     console.log(res);
     let headers = res.headers;
     console.log(headers);
  }) // ...and returning data
                         .catch((error:any) => Observable.throw(error || 'Server error')); //...errors if any
    }  
    renameTopic (body: Topic): Observable<Object> {
        let headers      = new Headers({ 'Content-Type': 'text/plain'}); // ... Set content type as text in order not to trigger preflight OPTIONS request
        let options       = new RequestOptions({ headers: headers}); // Create a request option
	let bodyString = JSON.stringify(body); // Stringify payload
      //alert(bodyString)
      return this.http.put(this.topicsUrl + "/topics/rename/topic/from/to", bodyString, options) // ...using post request
                         .map((res:Response) => {
     console.log(res);
     let headers = res.headers;
     console.log(headers);
  }) // ...and returning data
                         .catch((error:any) => Observable.throw(error || 'Server error')); //...errors if any
    }  

    updateTopicValue (body: Topic): Observable<Object> {
        let headers      = new Headers({ 'Content-Type': 'text/plain'}); // ... Set content type as text in order not to trigger preflight OPTIONS request
        let options       = new RequestOptions({ headers: headers}); // Create a request option
	let bodyString = JSON.stringify(body); // Stringify payload
  return this.http.put(this.topicsUrl + "topics/" + body.ID + "/value", bodyString, options) // ...using post request
                         .map((res:Response) => {
     console.log(res);
     let headers = res.headers;
     console.log(headers);
  }) // ...and returning data
                         .catch((error:any) => Observable.throw(error || 'Server error')); //...errors if any
    }  

    archiveTopic (body: Topic): Observable<Object> {
        let headers      = new Headers({ 'Content-Type': 'text/plain'}); // ... Set content type as text in order not to trigger preflight OPTIONS request
        let options       = new RequestOptions({ headers: headers}); // Create a request option
	let bodyString = JSON.stringify(body); // Stringify payload
      return this.http.put(this.topicsUrl + "topics/archive/disable/" + body.ID, bodyString, options) // ...using post request
                         .map((res:Response) => {
     console.log(res);
     let headers = res.headers;
     console.log(headers);
  }) // ...and returning data
                         .catch((error:any) => Observable.throw(error || 'Server error')); //...errors if any
    }  

    deleteTopic (id: String): Observable<Object> {
	let options       = new RequestOptions(); // Create a request option
  return this.http.delete(this.topicsUrl+"topics/" + id, options) // ...using delete request
                         .map((res:Response) => res) // ...and returning data
                         .catch((error:any) => Observable.throw(error || 'Server error')); //...errors if any
    }
}



// WEBPACK FOOTER //
// ./src/app/services/topic.service.ts